import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import entryGuideService from '../../services/entryGuideService';
import EntryGuideForm from '../../components/EntryGuides/EntryGuideForm';
import Toast from '../../components/Common/Toast';
import FormLoadingSpinner from '../../components/Common/FormLoadingSpinner';

const EditReceptionGuide = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [entryGuide, setEntryGuide] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    const loadEntryGuide = async () => {
      try {
        const response = await entryGuideService.getEntryGuide(id);
        if (response.success) {
          setEntryGuide(response.data);
        } else {
          setToast({ isOpen: true, message: 'Guía no encontrada', type: 'error' });
          setTimeout(() => navigate('/warehouses'), 2000);
        }
      } catch (error) {
        console.error('Error al cargar guía:', error);
        setToast({ isOpen: true, message: 'Error al cargar la guía', type: 'error' });
        setTimeout(() => navigate('/warehouses'), 2000);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      loadEntryGuide();
    }
  }, [id, navigate]);

  const handleSuccess = () => {
    setToast({ isOpen: true, message: 'Guía de recepción actualizada exitosamente', type: 'success' });
    setTimeout(() => {
      navigate(`/warehouses/${entryGuide?.warehouse_id}/documents`);
    }, 1500);
  };

  const handleCancel = () => {
    navigate(`/warehouses/${entryGuide?.warehouse_id}/documents`);
  };

  if (loading) {
    return (
      <div className="p-6">
        <div className="max-w-5xl mx-auto">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-gray-800">Editar Guía de Recepción</h1>
            <p className="text-gray-600 mt-1">Modifique la información de la guía de recepción</p>
          </div>
          <FormLoadingSpinner message="Cargando guía…" hint="Obteniendo ítems y datos del almacén" />
        </div>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Editar Guía de Recepción</h1>
          <p className="text-gray-600 mt-1">Modifique la información de la guía de recepción</p>
        </div>
        <EntryGuideForm
          isOpen={true}
          onClose={handleCancel}
          entryGuide={entryGuide}
          warehouseId={entryGuide?.warehouse_id}
          onSuccess={handleSuccess}
          isPageMode={true}
          isReception={true}
        />
        <Toast isOpen={toast.isOpen} message={toast.message} type={toast.type} onClose={() => setToast({ ...toast, isOpen: false })} />
      </div>
    </div>
  );
};

export default EditReceptionGuide;

